import React from 'react';
import clsx from 'clsx';
import RowElement from '../DataElements/RowElement'
import {
    NameTextField,
} from '../../../styling/Styles'

const TextareaComponent = (props) => {

    const {
        deleteComponent,
        placeholder,
        required,
        changePlaceholder,
        changeCheckbox
    } = props;

    const [displayContent, setDisplayContent] = React.useState(false); 

    return(
        <div className={clsx('spacingTopDiv')}>

            <RowElement
                label='Textarea'
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteComponent}
            />

            <div className={clsx('spacingTopDiv', 'spacingLeftDiv','spacingRightDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>  
                <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
                    <div className={clsx('flexRowDirection')}>
                        <div> Placeholder : </div>
                        <span style={{marginLeft: '5vw'}}>&nbsp;</span>
                        <NameTextField 
                            id='PlaceholderType'
                            value={placeholder}
                            onInput={e =>changePlaceholder(e)}
                        />
                    </div>
                    <div className={clsx('flexRowDirection')} style={{marginTop: '1vw'}}>
                        <div> Required</div>
                        <div style={{marginLeft: '6.7vw'}}>&nbsp;</div>
                        {required !== null && required !== undefined &&
                            <input 
                                type='checkbox'
                                checked= {required}
                                onChange={e => changeCheckbox(e)}
                                style={{width: '1vw', height: '1vw', marginTop: '0.2vw'}}
                            />
                        }
                    </div>
                </div>
                
            </div>

            <hr className={clsx('blueLine','spacingTopDiv')}/>
        </div>
    )

}

export default TextareaComponent;